/*
* @date 2018-04-13
* @author hyt
*/ 
// 支付模块
import $event from './../../../common/event.js';
var payMode = {
	init: function() {
		this.initDomEvent();
	},

	// 支付部分dom
	payModeDom: function() {
		return `
			<div class="zl_pay_mode">
	            <div class="zl_common_list">
	                <p class="zl_common_title">支付方式</p>
	                <ul class="zl_common_text clearfix">
	                    <li class="zl_pay icon-sanjiaoxuanzhong iconfont fl" data-check="wx">
	                        <span class="iconfont weixin"></span>微信支付
	                    </li>
	                    <li class="zl_pay iconfont fl" data-check="ali">
	                        <span class="iconfont zhifubao"></span>支付宝支付
	                    </li>
	                    <li class="zl_pay iconfont fl" data-check="pmc">
	                        其他支付方式
	                    </li>
	                </ul>
	            </div>
	    	</div>`;
	},

	// 提交部分dom
	submitDom: function() {
		return `
			<div class="zl_submit">
	            <div class="zl_submit_sure">确定</div>
	            <p class="zl_submit_relu">
	                <span class="zl_submit_item">
	                <i class="icon-duoxuanxuanzhong iconfont"></i>
	                我已阅读并同意
	                </span>
	                <a href="http://about.58.com/337.html#h" target="_blank">推广规则</a>
	            </p>
	    	</div>`;
	},
	
	// 事件绑定
	initDomEvent: function() {
		$event($('body')).$on('click', '.zl_submit_item', function() {
			var $this = $(this);
			var $dom = $this.find('.iconfont');
		    if($dom.hasClass("icon-duoxuanxuanzhong")){
		        $dom.removeClass("icon-duoxuanxuanzhong").addClass("icon-duoxuankuang");
		    }else{
		        $dom.addClass("icon-duoxuanxuanzhong").removeClass("icon-duoxuankuang");
		    }
		    if($this.parent().parent().parent().find(".zl_newYe_list").length > 0){
		        $(".zl_submit_sure").toggleClass("zl_submit_quit");
		    }
		})
	}
}

export default payMode;